module.exports = __webpack_public_path__ + "static/media/gasPump.fd394288.svg";